import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createMoldItem,
  getAllMoldItems,
  getDataForEdit,
  updateMoldItem,
  deleteMoldItem,
} from "../../store/Mold/MoldSliceApi";
import { getProductItems } from "../../store/AppLevelApi/AppLevelApi";
import { moldSliceAction } from "../../store/Mold/MoldSlice";
import { headTitle } from "../../utility/GetTableListName";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsMold } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialMoldFormData } from "../../ConstantData/InitialData";
import { ErrorMoldFormData } from "../../ConstantData/ErrorOption";
function Mold() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllMoldItems()); //initial list data
    // dispatch(getProductItems("product"));
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const moldList = useSelector((state) => state.mold.moldList); //store user list

  const InitialFormDataStore = useSelector((state) => state.mold.initialData);
  const moldEditData = useSelector((state) => state.mold.dataEdit);
  const productList = useSelector((state) => state.applevel.productList);
  let moldFormError = useSelector((state) => state.mold.errorData);
  let isError = useSelector((state) => state.mold.isError);
  moldFormError = {
    ...ErrorMoldFormData,
    ...moldFormError,
  };
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsMold));
  if (productList.length > 0) {
    //to chage factory option coming from server
    newFormOptionsUser = FormOptionsMold.map((item) => {
      if (item?.labelName === "Product") {
        item.options = productList;
      }
      return item;
    });
  }

  const headTitleLabel = headTitle(FormOptionsMold, ["Name", "Product"]); //array is field that is included in list heading

  return ( 
    <MainComponent
      InitialFormData={InitialMoldFormData}
      createFun={createMoldItem} //create function coming from store
      updateFun={updateMoldItem} //update function coming from store
      getDataForEdit={getDataForEdit} //edit function coming from store
      delteFun={deleteMoldItem}
      FormOptions={newFormOptionsUser}
      OptionName="Create Mold"
      OptionNameList="Mold Type"
      generalList={moldList}
      headTitle={headTitleLabel}
      EditData={moldEditData}
      generalModuleList={productList} //list to add different module
      ErrorData={moldFormError}
      isError={isError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={moldSliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default Mold;
